export class PageBuilderAddURL {
  public static EndPoints = {
    page_config: {
      pageVersion: '/platform/page-designer/pageversion/{id}',
      page: '/platform/page-designer/page',
      dbSchema: '/database/',
      page_lock: '/platform/page-designer/page/{id}/lock',
      assetByVersion: '/platform/page-designer/asset/batch/{pageid}/version/{versionid}',
      pageExist: '/platform/page-designer/page/{pagename}/{orgid}',
      pageaudit: '/platform/page-designer/page/audit/pageaudit/{id}/{id2}',
      orgPageList: '/platform/page-designer/page/organization/{orgid}?returnUserPage=false',
      getMember: '/solution/formresponse/{id}/getByPageId/{pageId}',
      gridPageResult: '/platform/page-designer/page/grid-page/{id}',
      formPage: '/platform/page-designer/page/form-page/{id}',
      deleteRow: '/solution/formresponse/{id}/pageid/{pageId}',
      submitForm: '/solution/formresponse/create',
      updateForm: '/solution/formresponse/{id}',
      softDeleteRow: '/platform/page-designer/page/form-page/{pageId}/response/{id}/soft-delete',
      gridPageResultCount: '/platform/page-designer/page/grid-page/{id}/count'
    },
    supporting_document_rule: {
      list: '/platform/page-designer/supporting-document/rules',
      create: '/platform/page-designer/supporting-document/rules',
      update: '/platform/page-designer/supporting-document/rules/{id}',
      delete: '/platform/page-designer/supporting-document/rules/{id}',
      getAllWizardForms: '/platform/page-designer/page/ribbon-page/wizard/all',
      tabPageMetadata: '/platform/page-designer/tab/{id}/metadata',
      getAllRulesForStepper: '/platform/page-designer/supporting-document/rules/stepper',
      getDocumentsForPage: '/platform/page-designer/supporting-document',
      saveDocumentForSection: '/platform/page-designer/supporting-document',
      updateDocumentForSection: '/platform/page-designer/supporting-document/status',
      deleteDocumentForSection: '/platform/page-designer/supporting-document/{documentId}',
      replaceDocumentForSection: '/platform/page-designer/supporting-document/replace',
      syncSaveEndpoint: '/platform/page-designer/supporting-document/sync',
      syncDeleteEndpoint: '/platform/page-designer/supporting-document/sync/delete'
    },
    rbac: {
      asset: {
        listByPageID: '/asset/getpagebyid',
        batch: '/asset/batch/'
      },
      organization: {
        list: '/platform/page-designer/page/organization/'
      }
    },
    report: {
      report: '/report'
    },
    db: {
      schemaList: '/database/organization/{organizationid}',
      tableBySchemaName: '/database/{schema}',
      relatedTableFields: '/database/{table}/{schema}/related',
      columnsOfRelatedTables: '/database/{table}/related',
      fieldsOfRelatedTable: '/database/related',
      tableFields: '/database/{table}/{schema}/validColumn',
      tableColumns: '/database/{table}/{schema}/columns'
    },
    attachment: {
      uploadFile: '/common/files/upload-file',
      uploadKey: '/common/files/upload-key',
      list: '/solution/formresponse-attachment/{formid}/{responseid}',
      delete: '/solution/formresponse-attachment/{fileid}',
      downloadKey: '/common/files/download-key',
      documentView: '/common/files/document-view',
      deleteDocument: '/common/files/delete-file',
      createAttachment: '/solution/formresponse-attachment/create'
    },
    documents: {
      history: '/solution/formresponse/attachments/{responseid}/{formId}'
    },
    assessments: {
      getFormioJson:'/solution/assessment-page/pageversion',
      createNestedFormResponse: '/solution/formresponse/nested-form/submit',
      updateNestedFormResponse: '/solution/formresponse/nested-form/{formId}',
    },
    powerbi: {
      embedConfig: '/powerbi/embed-config'
    }
  };
}
